export const profileAlreadyExists = (name, existingProfiles) => {
  return existingProfiles.some(
    (account) => account.data().username.toLowerCase() === name.toLowerCase()
  );
};
